import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  gridMargin: {
    margin: '15px !important',
  },
  formLabel: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '20px',
    color: '#666666',
  },
  listItem: {
    padding: 0,
  },
  filename: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '16px',
    color: '#666666',
    textTransform: 'capitalize',
  },
}));
